import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
const themeLabels = {
  system: "System",
  light: "Light",
  dark: "Dark"
};
const lucideIconProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": true
};
const themeIcons = {
  system: /* @__PURE__ */jsxs("svg", {
    ...lucideIconProps,
    children: [/* @__PURE__ */jsx("rect", {
      width: "20",
      height: "14",
      x: "2",
      y: "3",
      rx: "2"
    }), /* @__PURE__ */jsx("line", {
      x1: "8",
      x2: "16",
      y1: "21",
      y2: "21"
    }), /* @__PURE__ */jsx("line", {
      x1: "12",
      x2: "12",
      y1: "17",
      y2: "21"
    })]
  }),
  light: /* @__PURE__ */jsxs("svg", {
    ...lucideIconProps,
    children: [/* @__PURE__ */jsx("circle", {
      cx: "12",
      cy: "12",
      r: "4"
    }), /* @__PURE__ */jsx("path", {
      d: "M12 2v2"
    }), /* @__PURE__ */jsx("path", {
      d: "M12 20v2"
    }), /* @__PURE__ */jsx("path", {
      d: "m4.93 4.93 1.41 1.41"
    }), /* @__PURE__ */jsx("path", {
      d: "m17.66 17.66 1.41 1.41"
    }), /* @__PURE__ */jsx("path", {
      d: "M2 12h2"
    }), /* @__PURE__ */jsx("path", {
      d: "M20 12h2"
    }), /* @__PURE__ */jsx("path", {
      d: "m6.34 17.66-1.41 1.41"
    }), /* @__PURE__ */jsx("path", {
      d: "m19.07 4.93-1.41 1.41"
    })]
  }),
  dark: /* @__PURE__ */jsx("svg", {
    ...lucideIconProps,
    children: /* @__PURE__ */jsx("path", {
      d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9"
    })
  })
};
export function ThemePreferenceIcon({
  preference
}) {
  return themeIcons[preference];
}
export function ThemeItemLabel({
  preference
}) {
  return themeLabels[preference];
}
export function ThemePreferenceItemContent({
  preference,
  showLabel = true
}) {
  return /* @__PURE__ */jsxs("span", {
    class: "inline-flex items-center gap-inline",
    "aria-label": showLabel ? void 0 : themeLabels[preference],
    children: [/* @__PURE__ */jsx(ThemePreferenceIcon, {
      preference
    }), showLabel ? /* @__PURE__ */jsx(ThemeItemLabel, {
      preference
    }) : void 0]
  });
}